var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenThumbsUp({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33203 8.41927C1.33203 7.72891 1.89168 7.16927 2.58203 7.16927C3.27239 7.16927 3.83203 7.72891 3.83203 8.41927V13.4193C3.83203 14.1096 3.27239 14.6693 2.58203 14.6693C1.89168 14.6693 1.33203 14.1096 1.33203 13.4193V8.41927Z",
    fill: "#3A836C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66536 8.28038V12.8059C4.66536 13.4372 5.02204 14.0143 5.58668 14.2966L5.62821 14.3174C6.09106 14.5488 6.60144 14.6693 7.11893 14.6693H11.6324C12.4268 14.6693 13.1109 14.1085 13.2667 13.3295L14.2667 8.32947C14.4729 7.29815 13.6841 6.33594 12.6324 6.33594H9.66536V3.0026C9.66536 2.08213 8.91917 1.33594 7.9987 1.33594C7.53846 1.33594 7.16537 1.70903 7.16537 2.16927V2.72483C7.16537 3.44606 6.93144 4.14784 6.4987 4.72483L5.33203 6.28038C4.89929 6.85737 4.66536 7.55915 4.66536 8.28038Z",
    fill: "#3A836C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenThumbsUp);
export default __webpack_public_path__ + "static/media/green-thumbs-up.5ea93493b6b129039591cb2d47c001f4.svg";
export { ForwardRef as ReactComponent };